export class GlobalNotificationModule {
    constructor() {
      
            this.init();
       
    }

    init() {
        let _this = this;

        $(window).on('load', function () {
           
                _this.registerClick();
            
        });
    }

    registerClick() {
        $('.panel-title').on('click', function (e) {
            e.preventDefault();
          //  $('#collapseTwo').removeClass('DefaultDiv');
            $('#collapseTwo').removeClass('toggleDiv');
        });
    }
}